var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"hero","data-aos":"zoom-out","data-aos-delay":"100"}},[_c('div',{staticClass:"container"},[_c('banner',{attrs:{"list":_vm.banner_list}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }